export const SUBJECT_QUERY_PARAM = 'betreff';

export const createName = (firstName: string | undefined, lastName: string): string => {
	return `${firstName ? firstName + ' ' : ''}${lastName}`;
};

export const createMessage = (data: Record<string, string>): string => {
	let message = '';
	Object.entries(data).forEach(([key, value]) => {
		message += `${key}:\n${value}\n\n`;
	});
	return message;
};
